import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationsApi } from 'entities/Integrations'

export type IntegrationType =
  | 'activecampaign'
  | 'infusionsoft'
  | 'pipedrive'
  | 'intercom'
  | 'aircall'

export class IntegrationTimelineStore {
  private _dailyBundles = false
  private _dailyBundles1_0 = false
  private _integrationType: IntegrationType
  private _isReverted: boolean

  constructor(
    private _entities: IEntitiesStore,
    integrationType: IntegrationType,
    isReverted = true
  ) {
    this._integrationType = integrationType
    this._isReverted = isReverted
    makeAutoObservable(this)
  }

  init() {
    const settings = this._entities.userSettingsStore

    runInAction(() => {
      // used daily-bundles inverse value for get and send data
      this._dailyBundles = this._isReverted
        ? !settings.getItem('daily-bundles')?.settings?.[this._integrationType]
        : !!settings.getItem('daily-bundles')?.settings?.[this._integrationType]

      const integrationSettings = settings.getItem(`integrations-${this._integrationType}`)
      const sendTimeline = integrationSettings?.settings?.['send_timeline'] as boolean

      this._dailyBundles1_0 = sendTimeline || false
    })
  }

  get dailyBundles() {
    return this._dailyBundles
  }

  get dailyBundles1_0() {
    return this._dailyBundles1_0
  }

  onDailyBundlesToggle = () => {
    runInAction(() => {
      this._dailyBundles = !this.dailyBundles
    })

    this._entities.userSettingsStore.updateSetting({
      settingsKey: this._integrationType,
      value: this._isReverted ? !this.dailyBundles : this.dailyBundles,
      featureKey: 'daily-bundles',
    })
  }

  onDailyBundlesToggle1_0 = async () => {
    runInAction(() => {
      this._dailyBundles1_0 = !this.dailyBundles1_0
    })

    const params = {
      settingsKey: 'send_timeline',
      value: this.dailyBundles1_0,
      featureKey: `integrations-${this._integrationType}`,
    }

    try {
      await IntegrationsApi.putIntegrationSettings1_0(params, {})
    } catch (error) {
      logger.error(error)
    }
  }
}
